import IconBase from "./IconBase";

const ReloadIcon = props => (
  <IconBase {...props}>
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="m13 9 2 2 2-2" />
      <path d="M15 11V8a3 3 0 0 0-3-3H6M7 11 5 9l-2 2" />
      <path d="M5 9v3a3 3 0 0 0 3 3h6" />
    </g>
  </IconBase>
);

export default ReloadIcon;
